/**
 * This is a wrapper component for different Layouts.
 * Topbar should be added to this wrapper.
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import css from './LayoutWrapperTopbar.css';
import { parse } from '../../util/urlHelpers';
import {
    NOTIFICATION_FEED_URL_STATE_KEY,
    NOTIFICATION_FEED_URL_STATE_NAVIGATED_FROM,
} from '../../customUserNotificationEvents-config';
import { InlineTextButton } from '../Button/Button';
import { IconShevronLeft } from '../../icons';
import { useIsMobile } from '../../hooks/useIsMobile';
import UserCustomNotificationBadge from '../UserCustomNotificationBadge';
import { useDispatch } from 'react-redux';
import { TOGGLE_NOTIFICATION_FEED } from '../../ducks/UI.duck';
import IconClose from '../IconClose/IconClose';
import { useCurrentPage } from '../../hooks/useCurrentPage';
import { BottomBarMobile } from '../../components';

const LayoutWrapperTopbar = props => {
    const dispatch = useDispatch();
    const history = useHistory();
    const currentPage = useCurrentPage();
    const { location } = history;
    const [isMobile, , computing] = useIsMobile();
    const [notificationFeedOpen, setNotificationFeedOpen] = useState(false);
    const locationSearchParamsParsed = parse(location.search);

    const toggleNotificationFeed = payload => dispatch({ type: TOGGLE_NOTIFICATION_FEED, payload });

    const { className, rootClassName, children } = props;

    const isNotificationFeedNavigatedFrom = Boolean(
        isMobile &&
            !computing &&
            locationSearchParamsParsed &&
            typeof locationSearchParamsParsed === 'object' &&
            locationSearchParamsParsed[NOTIFICATION_FEED_URL_STATE_KEY] &&
            locationSearchParamsParsed[NOTIFICATION_FEED_URL_STATE_KEY] ===
                NOTIFICATION_FEED_URL_STATE_NAVIGATED_FROM
    );

    const classes = classNames(rootClassName || css.root, className, {
        [css.notificationFeedTopBar]: isNotificationFeedNavigatedFrom,
    });

    const handleFeedDismissed = () => {
        const queryParams = new URLSearchParams(location.search);
        queryParams.delete(NOTIFICATION_FEED_URL_STATE_KEY);

        history.replace({
            search: queryParams.toString(),
        });
    };
    const handleFeedOpen = () => {
        setNotificationFeedOpen(true);
        toggleNotificationFeed(true);
    };

    if (isNotificationFeedNavigatedFrom) {
        return (
            <div className={classes}>
                <InlineTextButton
                    className={css.notificationFeedPrimaryButton}
                    onClick={handleFeedOpen}
                >
                    <IconShevronLeft />
                    <span>Updates</span>
                </InlineTextButton>
                <InlineTextButton
                    className={css.notificationFeedSecondaryButton}
                    onClick={handleFeedDismissed}
                >
                    <span>Schliessen</span>
                    <IconClose rootClassName={css.closeIcon} />
                </InlineTextButton>
                {notificationFeedOpen && (
                    <UserCustomNotificationBadge renderCustomElement={({ modal }) => modal} />
                )}
                {/** Topbar is not rendered here, so the bottom bar is provided by the wrapper */}
                <BottomBarMobile currentPage={currentPage} />
            </div>
        );
    }

    return <div className={classes}>{children}</div>;
};

const { node, string } = PropTypes;

LayoutWrapperTopbar.propTypes = {
    children: node.isRequired,
    className: string,
    rootClassName: string,
};

export default LayoutWrapperTopbar;
